export class SessionStorageConst {
  static readonly autoSyncSessionUser = 'chemical-equipment-calibration.auto-sync.session-user';
}
